<template>
  <label :class="`bundle bundle-${color}`">
    {{ $t(`autocaller_v2.task.state.${value}`) }}
  </label>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    computed: {
      color: function() {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.value) {
          case 'success': {
            return 'green';
          }
          case 'processing': {
            return 'fresh';
          }
          case 'fail': {
            return 'error';
          }
          case 'pending': {
            return 'gray';
          }
          case 'canceled': {
            return 'gray';
          }
          default: {
            return 'default';
          }
        }
        /* eslint-enable */
      }
    }
  };
</script>
